var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "ul",
        { staticClass: "asc__header-shortcuts" },
        _vm._l(_vm.shortcuts, function(item, i) {
          return _c(
            "li",
            { key: "i" + i },
            [
              _c(
                "router-link",
                {
                  attrs: {
                    "active-class": "asc__navigation-shortcuts-active",
                    exact: "",
                    to: { name: item.router }
                  }
                },
                [
                  _c("i", { class: item.icon ? item.icon : "" }),
                  _vm._v("\n        " + _vm._s(item.title) + "\n      ")
                ]
              )
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("mega-menu", { attrs: { data: _vm.navigation } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74433326", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74433326","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shortcuts.vue
// module id = null
// module chunks = 